import React from 'react';

export default function SideBySideTeamLogo({ homeTeamLogo, awayTeamLogo, cy, cx, width, height }: { homeTeamLogo: string, awayTeamLogo: string, cy: number, cx: number, width: number, height: number }) {
  const separatorStrokeWidth = 2;
  const clipPathIdHome = 'clip-home';
  const clipPathIdAway = 'clip-away';

  const awayClipPath = `M 0 0 L ${width * 0.63} 0 L ${width * 0.35} ${height} L 0 ${height} Z`;
  const homeClipPath = `M ${width * 0.63} 0 L ${width} 0 L ${width} ${height} L ${width * 0.35} ${height} Z`;
  const transform = `translate(${cx - width / 2}, ${cy - height / 2})`;

  return (
    <svg x={114} y={44}>
    <g>
      <defs>
        <clipPath id={clipPathIdHome}>
          <path d={homeClipPath} />
        </clipPath>
        <clipPath id={clipPathIdAway}>
          <path d={awayClipPath} />
        </clipPath>
      </defs>
      <image href={awayTeamLogo} width={width} height={height} clipPath={`url(#${clipPathIdAway})`} />
      <image href={homeTeamLogo} width={width} height={height} clipPath={`url(#${clipPathIdHome})`} />
      <line
        x1={width * 0.63 - separatorStrokeWidth / 2}
        y1={0}
        x2={width * 0.35 + separatorStrokeWidth / 2}
        y2={height}
        stroke="#A3A8B1"
        strokeWidth={separatorStrokeWidth}
        />
    </g>
        </svg>
  );
};

